import { RouteConfigEntryComponent, RouteConfigParams } from './route-config-entry/route-config-entry.component';
import { RouteConfigDialogService } from './route-config-dialog.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { SubscriptionMgr } from 'app/model/SubscriptionMgr';
import { RouteInfo } from 'app/model/services/route.service';

@Component({
  selector: 'app-route-config-dialog',
  template: ''
})
export class RouteConfigDialogComponent implements OnDestroy {
  modalRef?: NgbModalRef;
  subscriptionMgr: SubscriptionMgr = new SubscriptionMgr();
  lastTitle: string | null = null;
  constructor(private modalService: NgbModal, private service: RouteConfigDialogService) {
    this.subscriptionMgr.Subscribe(this.service.requests, (params?: RouteConfigParams) => {
      this.modalRef = this.modalService.open(RouteConfigEntryComponent, { backdrop: 'static' });
      (this.modalRef.componentInstance as RouteConfigEntryComponent).Show(params);
    });
  }
  ngOnDestroy() {
    this.subscriptionMgr.CancelSubscriptions();
  }

}
